export default function TopNavSkeleton() {
  return (
    <nav className="bg-white shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 custom-max-w-920px">
        <div className="relative flex h-16 justify-between">
          <div className="flex items-center">
            <div className="h-8 w-28 bg-gray-200 animate-pulse rounded"></div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              <div className="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 hidden sm:flex">
            <div className="w-16 h-6 bg-gray-200 animate-pulse rounded"></div>
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            <div className="w-10 h-10 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </div>
      </div>
    </nav>
  )
}
